module.exports = __webpack_public_path__ + "img/passenger_icon.1858601b.png";